import { Directive } from '@angular/core';

@Directive({
  standalone: false,
  selector: '.scroll-top',
  host: { '(click)': 'scrollTop()' }
})
export class ScrollTopDirective {
  scrollTop(): void {
    window.scrollTo(0, 0);
  }
}
